import { render, staticRenderFns } from "./PontaDeLanca.vue?vue&type=template&id=239c0b2e&scoped=true"
import script from "./PontaDeLanca.vue?vue&type=script&lang=js"
export * from "./PontaDeLanca.vue?vue&type=script&lang=js"
import style0 from "./PontaDeLanca.vue?vue&type=style&index=0&id=239c0b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239c0b2e",
  null
  
)

export default component.exports